<template>
    <dashboard-layout>
      <template v-if="fetchDataLoading">
        <div class="big-white-card2">
          <center><div class="loader"></div></center>
        </div>
            </template>
            <template v-else>
              <router-link to="/administrative/sales-execs" > 
                    <div class="back-card mr-2" style="margin-left: 40px">
                      <span class="profile-text"><i class="fas fa-arrow-left"></i> Back</span>
                  </div>
                  </router-link><hr>
      <div class="head-text3">{{ SEDetails.FirstName }} {{ SEDetails.LastName }} - Onboarded Merchants</div>
      <div class="subhead-text3">All business owners this sales executive onboarded will be listed here.</div>
      <div class="UserInfo-card">
        <table class="table1">
  <tr>
    <th>User ID</th>
    <th>Full Name</th>
    <th>Email</th>
    <th>Department</th>
    <th>Role</th>
  </tr>
  <tr>
    <td>{{ SEDetails.UserId }}</td>
    <td>{{ SEDetails.FirstName }} {{ SEDetails.LastName }}</td>
    <td>{{ SEDetails.Email }}</td>
    <td>{{ SEDetails.Department }}</td>
    <td>{{ SEDetails.Role }}</td>
  </tr>
       </table>

      </div>


      <div class="big-card">
      <div class="horizontal-container">

        <!-- Search bar -->
        <div class="search-bar" style="max-width: 700px;">
        <div class="search-icon ">
          <img src="@/components/img/Sales_Assests/Search.svg" alt="Search Icon" style="padding-right: 10px;">
        </div>
        <input type="text" class="form-control ml-1" v-model="searchTerm"  style="width: 500px; height: 35px; color:#000; font-size: 13px; border: 1px solid #D1D5DB;" placeholder="  Search with User ID, Full name...">
      </div>
      </div><hr><hr>


      <div class="custom-table-container" :key="currentPage">
        
      <table class="custom-table">
        <thead>
          <tr>
            <th >Date Created</th>
            <th>Merchant ID</th>
            <th>Merchant Name</th>
            <th>Businesses</th>
            <th>Locations</th>
            <th>Cashiers</th>
            <th></th> 
          </tr>
        </thead>
        <tbody>
          <template v-if="filteredRows.length === 0">
        <tr>
          <td colspan="7" style="text-align: center;">No records found</td>
        </tr>
      </template>
          <template v-else-if="searchTerm && filteredRows.length > 0">
          <tr v-for="(row, index) in filteredRows" :key="index" class="table-row" @click="navigateToDetails(row)">
            <td>{{ row.dateCreated }}</td>
            <td>{{ row.merchantId }}</td>
            <td>{{ row.firstname }} {{ row.lastname }}</td>
            <td>{{ row.businessCount }}</td>
            <td>{{ row.locationCount }}</td>
            <td>{{ row.cashiersCount }}</td>
            <td class="vertical-dots-cell">
              <!-- Vertically aligned dots -->
              <img src="@/components/img/Sales_Assests/dots.svg" 
                   alt="View Icon" 
                   style="padding-right: 10px;"
                   @click.stop="togglePopup(row)">

              <!-- Popup tab -->
              <div class="popup-tab" v-show="row.showPopup">
                <router-link v-if="row.merchantId" :to="{ path: '/administrative/sales-execs/merchants', query: { MID: row.merchantId } }" class="popup-item nav-link">
                  <img v-if="!hovered" src="@/components/img/Sales_Assests/blackeye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  <img v-else src="@/components/img/Sales_Assests/coloreye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  View Details
                </router-link>
              </div>
            </td>
          </tr>
          </template>
          <template v-else>
           <tr v-for="(row, index) in visibleRows" :key="index" class="table-row" @click="navigateToDetails(row)">
            <td>{{ row.dateCreated }}</td>
            <td>{{ row.merchantId }}</td>
            <td>{{ row.firstname }} {{ row.lastname }}</td>
            <td>{{ row.businessCount }}</td>
            <td>{{ row.locationCount }}</td>
            <td>{{ row.cashiersCount }}</td>
            <td class="vertical-dots-cell">
              <!-- Vertically aligned dots -->
              <img src="@/components/img/Sales_Assests/dots.svg" 
                   alt="View Icon" 
                   style="padding-right: 10px;"
                   @click.stop="togglePopup(row)">

              <!-- Popup tab -->
              <div class="popup-tab" v-show="row.showPopup">
                <router-link v-if="row.merchantId" :to="{ path: '/administrative/sales-execs/merchants', query: { MID: row.merchantId, SEID: SEID } }" class="popup-item nav-link">
                  <img v-if="!hovered" src="@/components/img/Sales_Assests/blackeye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  <img v-else src="@/components/img/Sales_Assests/coloreye.svg" 
                       alt="eye Icon" 
                       class="popup-icon"
                       style="height: 12px; width: auto; margin-left: 2px;">
                  View Details
                </router-link>
              </div>
            </td>
          </tr>
        </template>

        </tbody>
      </table>
      <div class="pagination">
      <span>{{ currentPageStart }} - {{ currentPageEnd }} of {{ totalRows }}</span>
      <img src="@/components/img/Sales_Assests/previousbutton.svg" 
      class="pagination-icon1"
      alt="Prev Icon" 
      @click="prevPage">
      <img src="@/components/img/Sales_Assests/nextbutton.svg" 
      class="pagination-icon2"
      alt="Next Icon" 
      @click="nextPage">
    </div>
    <hr>
    </div>
      </div>

      <account-settings-modal 
      :showMoreDetailsModal="showMoreDetailsModal"  
      :showLocationDetailsModal="showLocationDetailsModal"  
      @close-modal="closeMoreDetailsModal" 
    >
    </account-settings-modal >

    <add-cashier-modal 
      :showLocationDetailsModal="showLocationDetailsModal" 
      @open-modal2="openLocationModal" 
      @close-modal2="closeLocationModal" 
    >
    </add-cashier-modal>

    </template>

    </dashboard-layout>
  </template>
  
  <script>
  import DashboardLayout from '@/components/DashboardLayout.vue';
  import axios from 'axios'; 
  
  export default {
    name: 'Details-businesses',
  
    components: {
      DashboardLayout,
    },
  
    data() {
    return {

        showMoreDetailsModal: false,
        showLocationDetailsModal: false,
        selectedMonth: new Date().getMonth() + 1, // January is 1-based
      selectedYear: new Date().getFullYear(),
      months: [
        'January', 'February', 'March', 'April',
        'May', 'June', 'July', 'August',
        'September', 'October', 'November', 'December'
      ],
      years: [],
    businessNames: [],
        searchTerm: '',
        selectedRowData: {},
        currentPage: 1,
        rowsPerPage: 10,
        totalRows: 0,
        searchTerm3: '',
        showPopup: Array(3).fill(false),
        userID: null,
        SEDetails: null,
        SEID: null,
        MerchantDetails: null,
        fetchDataLoading: true,
        selectedBusiness: null,
        selectedBusinessDetails: {},
        businessDetails: null,

        tableData: [],


    };
  },
  async mounted() {
    this.userID = sessionStorage.getItem('userId');

    try{
      await this.fetchSEDetails();
      await this.fetchAllOnboardedMerchants(this.SEID);
      this.totalRows = this.tableData.length;
      this.fetchDataLoading = false;
    } catch(error){
      console.log(error);
    }

document.addEventListener('click', this.closePopups);
this.totalRows = this.tableData.length;


const currentYear = new Date().getFullYear();
for (let year = 2000; year <= 2030; year++) {
  this.years.push(year);
}
console.log(currentYear);
  },

  
  computed: {

filteredRows() {
let filteredData = [];
let startIndex = 0;
let endIndex = 0;
const term = this.searchTerm.toLowerCase().trim();
if (!term) return this.tableData;

// Filter rows based on search term
filteredData = this.tableData.filter(row =>
  Object.values(row).some(value =>
    value && value.toString().toLowerCase().includes(term)
  )
);

// Apply pagination to filtered rows
startIndex = (this.currentPage - 1) * this.rowsPerPage;
endIndex = startIndex + this.rowsPerPage;

return filteredData.slice(startIndex, endIndex);
},


visibleRows() {
const startIndex = (this.currentPage - 1) * this.rowsPerPage;
const endIndex = startIndex + this.rowsPerPage;

// Filter rows based on search term
const filteredRows = this.filteredRows;

// Slice the filtered rows based on pagination
return filteredRows.slice(startIndex, endIndex);
},
currentPageStart() {
if (this.searchTerm) {
  return Math.min((this.currentPage - 1) * this.rowsPerPage + 1, this.filteredRows.length);
} else {
  return Math.min((this.currentPage - 1) * this.rowsPerPage + 1, this.totalRows);
}
},

currentPageEnd() {
if (this.searchTerm) {
  return Math.min(this.currentPage * this.rowsPerPage, this.filteredRows.length);
} else {
  return Math.min(this.currentPage * this.rowsPerPage, this.totalRows);
}
}


},

  methods: {

    navigateToDetails(row) {
    if (row.merchantId) {
      this.$router.push({
        path: '/administrative/sales-execs/merchants',
        query: { MID: row.merchantId }
      });
    }
  },

    async fetchSEDetails() {
      try {
  
        const SEID = this.$route.query.SEID;
        const url = `${this.$config.GETUSERSBYID_ENDPOINT}/${SEID}`;
        this.SEID = SEID;
        const response = await axios.get(url);
        if(response.status == 200){
          this.SEDetails = response.data;

        }
        
        
        } catch (error) {
        console.error(error);
       
      }
    },

    async fetchAllOnboardedMerchants(SEID) {
    try {
      const response = await axios.get(`${this.$config.GETMERCHANT_ENDPOINT}/${SEID}`);
     
      this.tableData = response.data.data;
      console.log('Value is for onborded',  this.onboardedData);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  },

    updateSelectedBusinessDetails() {
    this.selectedBusinessDetails = this.businessDetails.find(business => business.name === this.selectedBusiness);
    this.tableData = this.selectedBusinessDetails.locations;
  },


    updateRightSectionDetails(selectedBusinessName) {
    // Find the selected business details
    const selectedBusiness = this.MerchantDetails.businesses.find(business => business.name === selectedBusinessName);
    if (selectedBusiness) {
      this.selectedBusinessDetails = selectedBusiness;
    }
  },

    async fetchMerchantDetails() {
      try {
  
        const MerchantID = this.$route.query.MID;
        const url = `${this.$config.GETMERCHANT_ENDPOINT}/${this.userID}/${MerchantID}`;
        this.currentMerchantID = MerchantID;
        const response = await axios.get(url);
        this.MerchantDetails = response.data.data;
        this.businessDetails = response.data.data.businesses; 

         
    this.businessNames = this.MerchantDetails.businesses.map(business => business.name);

      console.log('All business names', this.businessNames);
        
        } catch (error) {
        console.error(error);
       
      }
    },

    closeLocationModal(){
        this.showLocationDetailsModal = false;

    },
    openLocationModal() {
      this.showLocationDetailsModal = true;
     
    },

    openMoreSettingsModal() {
      this.showMoreDetailsModal = true;
     
    },

    closeMoreDetailsModal(){
        this.showMoreDetailsModal = false;
    },

    nextPage() {
    const totalPages = Math.ceil(this.totalRows / this.rowsPerPage);
    if (this.currentPage < totalPages) {
      this.currentPage++;
    }
  },
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  },



    toggleHover() {
            this.hovered = !this.hovered;
          
        },

        togglePopup(row) {
          this.tableData.forEach(row => {
        row.showPopup = false;
      });
          console.log('popup clicked', row);
    // Check if the row already has the showPopup property
    if (!Object.prototype.hasOwnProperty.call(row, 'showPopup')) {
      // If not, add it with an initial value of false
      this.$set(row, 'showPopup', false);
    }
    // Toggle the showPopup value for the corresponding row
    row.showPopup = !row.showPopup;
  },


    closePopups() {

      console.log('Close popup clicked');
      // Close all popups
      this.tableData.forEach(row => {
        row.showPopup = false;
      });
    },



    filterBusinessNames() {
    // Convert the search term to lowercase for case-insensitive matching
    const searchTerm = this.searchTerm.toLowerCase();
    
    // Filter the business names based on the search term
    this.filteredBusinessNames = this.businessNames.filter(businessName => {
      // Convert the current business name to lowercase for comparison
      const name = businessName.toLowerCase();
      
      // Return true if the business name contains the search term
      return name.includes(searchTerm);
    });
  },
  },

 
  
  };
  </script>
  
  <style scoped>

  .table-section{
    margin-top: 15px;
    max-height: 400px;
    max-width: 580px;
    overflow: auto;
  }
  .custom-table{
    overflow: auto;
  }

  .custom-table-container::-webkit-scrollbar {
  height: 6px;
  width: 6px; 
}

.custom-table-container::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; 
  border-radius: 3px;
}

.search-bar3 {
  position: absolute;
  margin-top: 15px;
}

.search-bar3 input[type="text"] {
  padding-left: 30px; /* Space for the icon */
}

  .view-more{
    margin-top: 30px;
    width: 100%;
    height: 50px;
    background-color: #F8F9FC;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    transition: transform 0.3s;
    cursor: pointer;
  }
  .view-more:hover{
    transform: scale(1.02);
  }

  .text-left {
    margin-right: auto;
    color: #000;
    font-size: 12px;
    font-weight: bold;
}

.icon-right {
    width: auto; 
    height: 19px; 
    margin-left: 10px; 
}


.oval-icon9{
    margin-left: 130px;
  }
  .oval-icon8{
    margin-left: 118px;
  }

.card2-border2{
  border-left: 1px solid #624915 ;
  border-right: 1px solid #624915 ;
  border-top: 1px solid #624915 ;
  border-bottom: 1px solid #624915 ;
}

.dashboard-cards2 {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  
}

.calendar-dropdown2 {
  border-radius: 5px;
  display: flex;
  margin-left: 0px;
  font-size: 12px;
  height: 25px;
  
}

  .business-table{
    max-height: 300px;
    overflow-y: auto;
    overflow-x: auto;
    margin-top: 40px; 
  }

  .business-table::-webkit-scrollbar {
  width: 6px; /* Set the width of the scrollbar */
}

.business-table::-webkit-scrollbar-thumb {
  background-color: #c6c5cb; /* Set the color of the scrollbar thumb */
  border-radius: 3px; /* Optional: Add rounded corners to the thumb */
}

  .add-business{
    
    transition: transform 0.3s;
    height: auto;
    width: 100px;
  }

  .add-business:hover{
    transform: scale(1.05);
  }

.business-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
}
.business-cell img {
  margin-left: auto;
}

.search-bar2 {
  position: absolute;
}

.search-bar2 input[type="text"] {
  padding-left: 30px; /* Space for the icon */
}

.left-upper{
    padding: 15px;
}

.left-section {
 width: 300px;
  background-color: #fff;

  border-right: 1px solid #F5EDFC;
}

.right-section {
  width: 700px;
  background-color: #fff;
  padding: 15px;
  padding-left: 60px;
  padding-right: 40px;
}


.big-card2  {
    background-color: #FFF; 
    margin: 20px 40px;  
    height: 700px;
    display: flex;
  }
  .UserInfo-card {
    background-color: #F1F3F9;
    margin: 20px 40px;
    padding: 20px;
  }
  
  .table1 {
    width: 100%;
    border-collapse: collapse;

    th, td {
    padding: 2px;
    text-align: left;
  }

  td{
    font-weight: bold;
    color: #212020;
    font-size: 13px;
  }
  
  th {
    width: 5%;
    font-size: 12px;
    font-weight: normal;
  }
  }
  
  
  </style>